import React from 'react';

const SandBox = ({ currentUser, dashboardStats, brands, recentlyContactedAffiliates, newAffiliatesByCountry }) => {
  const basePath = process.env.REACT_APP_API_URL || 'https://mars2.mediacle.net';
  const fetchApi = async () => {
      try{
         const response = await fetch(`${basePath}/api/sandBoxTest`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });  
      }
      catch(error){
         console.error('Error fetching affiliate data:', error);
      }
  }

  return (
    <div className="p-6 space-y-6">
      <div>
        <button 
          onClick={fetchApi} 
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
        >
          Fetch Page Data
        </button>
      </div>
    </div>
  );
};

export default SandBox;
